// extracted by mini-css-extract-plugin
export default {"otpContainer":"style_otpContainer__wp0sA","inputElement":"style_inputElement__4eS3j","root":"style_root__Xq4vx","otpDisplay":"style_otpDisplay__-bZLi"};